import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { max, min } from '../../../theme/breakpoints';

const backgroundAnimation = keyframes`
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-800px);
  }
`;

export const ShapeContainer = styled.div`
  position: absolute;
  top: 100px;
  left: 0;
  width: 100%;

  @media screen and ${min('tablet')} {
    top: auto;
    bottom: 0;
    width: 50%;
  }
  img {
    display: block;
    width: 100%;
  }
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    height: 100vh;
    left: 0;
    width: 100%;
    background: ${({ theme }) => theme.colors.White};
    z-index: 1;

    @media screen and ${min('tablet')} {
      display: none;
    }
  }
`;

export const ContentWrapper = styled(motion.div)`
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.colors.background};

  .reinsurance-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1600px;
    background-repeat: repeat;
    background-size: auto 50px;
    padding: 2.5rem 0;
    animation: ${backgroundAnimation} 60s infinite linear;
    opacity: ${({ theme }) => (theme.name === 'uplay' ? '0.2' : '1')};

    @media screen and ${min('tablet')} {
      background-size: auto 100px;
    }
  }
  &::after {
    content: '';
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${({ theme }) =>
      theme.name === 'uplay'
        ? 'linear-gradient(270.01deg, #1C2125 57.64%, rgba(28, 33, 37, 0) 74.49%)'
        : 'linear-gradient(270.01deg, #FFFFFF 57.64%, rgba(255, 255, 255, 0) 74.49%)'};
    z-index: 1;

    @media screen and ${min('tablet')} {
      display: block;
    }
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  padding: 2.25rem 0;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 2;

  .guy {
    height: 41.5625rem;

    @media screen and ${max('desktop')} {
      height: 30rem;
    }
    @media screen and ${max('tablet')} {
      height: 18.4375rem;
    }
  }
  @media screen and ${max('tablet')} {
    flex-direction: column;
    align-items: center;
  }
`;

export const CaptionText = styled.p``;

export const InfoSection = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  > h2,
  > p {
    text-align: center;

    @media screen and ${min('tablet')} {
      text-align: left;
    }
  }

  > h2 {
    font-size: 2.8125rem;
    line-height: 1.2;
    padding: 0;
    margin: 0 0 2rem;
    text-transform: none;

    @media screen and ${max('desktop')} {
      font-size: 1.75rem;
    }

    @media screen and ${max('tablet')} {
      font-size: 1.5rem;
    }
  }

  > p {
    margin: 0 0 2rem;
    font-family: ${({ theme }) => theme.fonts.primary.regular};
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.5rem;
    line-height: 1.6rem;
    letter-spacing: 0.04rem;

    @media screen and ${max('desktop')} {
      font-size: 1.25rem;
      line-height: 1.35rem;
    }

    @media screen and ${max('tablet')} {
      font-size: 1rem;
      line-height: 1.1rem;
      letter-spacing: 0.04rem;
    }
  }

  ${CaptionText} {
    font-size: 0.875rem;
    @media screen and ${max('desktop')} {
      font-size: 0.8rem;
    }
    @media screen and ${max('tablet')} {
      font-family: ${({ theme }) => theme.fonts.primary.regular};

      font-size: 0.75rem;
    }
  }

  @media screen and ${max('tablet')} {
    width: 60%;
  }

  @media screen and ${max('mobile')} {
    padding: 0;
  }

  @media screen and ${max('mobile')} {
    width: 100%;
    align-items: center;
  }
`;
